"use strict";
/**
 * =================================
 * オブジェクトのスタイル 設定
 * =================================
 */
/**
 * ---------------------------------
 * borderRadius
 * ---------------------------------
 */
const borderRadius = {
    full: '9999px',
    md: '4px',
    none: '0px',
    sm: '2px',
};
/**
 * ---------------------------------
 * boxShadow
 * ---------------------------------
 */
const boxShadow = {
    lg: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    md: '0px 2px 5px rgba(0, 0, 0, 0.16)',
    none: 'none',
    sm: '0px 1px 2px rgba(0, 0, 0, 0.16)',
};
/**
 * ---------------------------------
 * dropShadow
 * ---------------------------------
 */
const dropShadow = {
    lg: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    md: '0px 2px 5px rgba(0, 0, 0, 0.16)',
    none: 'none',
    sm: '0px 1px 2px rgba(0, 0, 0, 0.16)',
};
module.exports = {
    borderRadius,
    boxShadow,
    dropShadow,
};
